export const
    UNSELECTED_COMPLAINT_TYPE = "Należy wybrać rodzaj zgłoszenia!",
    NO_POSITIONS="Należy dodać przynajmniej jedną pozycję zgłoszenia!";


// WEBPACK FOOTER //
// ./src/const/ErrorMessages/ComplaintErrorMessages.js